import React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { Typography, Box } from '@mui/material';
import inventorySectorEmissions from '../../data/inventorySpeciesSectorEmissions.json';
import intemSectorEmissions from '../../data/intemSpeciesSectorEmissions.json';
import rhimeSectorEmissions from '../../data/rhimeSpeciesSectorEmissions.json';
import { chartColors } from '../../chartColors';

const modelColors = [chartColors.InTEM, chartColors.RHIME, chartColors.Inventory];

const transformData = (data, species) => {
  const sectorData = data.sectors;
  return sectorData.map((sector) => {
    const speciesData =
      species === 'total'
        ? sector.species.reduce((sum, s) => sum + (s.value || 0), 0)
        : sector.species.find((s) => s.name === species)?.value || 0;
    return {
      sector: sector.sector,
      value: speciesData,
    };
  });
};

const StackedBarCharts = ({ selectedSpecies }) => {
  const unsupportedSpecies = ['total', 'N2O', 'PFC', 'SF6', 'HFCs'];
  const isUnsupported = unsupportedSpecies.includes(selectedSpecies);
  if (isUnsupported) {
    return (
      <Box
        height="400px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        fontSize="1.5rem"
        color="#526777"
        bgcolor="#EAF0F2"
        borderRadius="8px"
        boxShadow="0 2px 6px rgba(0,0,0,0.1)"
      >
        Coming Soon: {selectedSpecies} Data
      </Box>
    );
  }

  const intemData = transformData(intemSectorEmissions, selectedSpecies);
  const rhimeData = transformData(rhimeSectorEmissions, selectedSpecies);
  const inventoryData = transformData(inventorySectorEmissions, selectedSpecies);

  const sectors = Array.from(new Set([...intemData.map((d) => d.sector),...rhimeData.map((d) => d.sector), ...inventoryData.map((d) => d.sector)]));

  const datasets = [
    {
      label: 'InTEM-2021',
      data: sectors.map(
        (sector) => intemData.find((d) => d.sector === sector)?.value || 0
      ),
    },{
      label: 'RHIME-2021',
      data: sectors.map(
        (sector) => rhimeData.find((d) => d.sector === sector)?.value || 0
      ),
    },
    {
      label: 'Inventory-2021',
      data: sectors.map(
        (sector) => inventoryData.find((d) => d.sector === sector)?.value || 0
      ),
    },
  ];

  return (
    <Box>
      <Typography style={{ paddingLeft: '2%' }}>
        Units: CO<sub>2</sub> equivalent (Mt)
      </Typography>
      <Typography style={{ paddingLeft: '2%' }}>Species: {selectedSpecies}</Typography>

      <BarChart
        series={datasets.map((set, idx) => ({
          ...set,
          color: modelColors[idx % modelColors.length], // Keep model colours consistent with the multiline plot
        }))}
        xAxis={[{ data: sectors, scaleType: 'band' }]}
        height={400}
        margin={{ top: 30, bottom: 63, left: 70, right: 30 }}
        legend={{
          direction: 'row',
          position: {
            vertical: 'bottom',
            horizontal: 'middle',
          },
        }}
      />
    </Box>
  );
};

export default StackedBarCharts;
